<template>
  <!-- #TODO:api沒有寵物照片 -->
  <v-main class="customMain" v-if="!$store.state.isLoading">
    <PopupAlert v-model="showProtect" @click:keep="clickTo('/location')" type="protect" />
    <BackOnTop title="寵物美容" :showMain="false" />
    <div class="info_wrappper">
      <Swiper @update-index="handleIndex" :data="pointCardList" />
      <div class="func_area">
        <div v-for="list in funList" :key="list.title" @click="clickTo(list.url)">
          <div class="">
            <img :src="list.src" />
          </div>
          <p>{{ list.title }}</p>
        </div>
      </div>
      <img
        style="position: absolute; width: 100%; left: 0; transform: translateY(110%)"
        src="@/assets/images/intersect.png"
        alt=""
      />
      <div class="title" v-if="!$store.state.isLoading">
        <img src="@/assets/images/title_reserve.png" alt="" />
        <p>我的預約</p>
      </div>
      <div class="bar">
        <div class="tabbar">
          <div
            :class="{ active: +barSelect === index }"
            v-for="(option, index) in optionsStatus"
            :key="option"
            @click="barSelect = index"
          >
            {{ option }}
          </div>
        </div>
      </div>
      <div class="reserve_container">
        <div v-if="(reserve_list.length || beauty_list.length) && !$store.state.isLoading">
          <div
            v-if="currentStatus.length !== 0"
            class="col-12"
            ref="listPage"
            @scroll="handleScroll"
          >
            <div v-for="(info, index) in currentStatus" :key="index">
              <div
                :class="`style-salon-history-reserve box ${getRecordStatusClass(info.status)}`"
                @click.prevent="
                  info.url ? $router.push(info.url) : (info.currentOpen = !info.currentOpen)
                "
              >
                <div class="imger">
                  <img
                    style="object-fit: cover; width: 48px; height: 48px"
                    :src="info.petImg"
                    alt=""
                  />
                  <p style="max-width: 48px; text-align: center">{{ info.name }}</p>
                </div>
                <div class="infor">
                  <div style="justify-content: space-between; width: 100%">
                    <div class="style-title-m">
                      {{ info.service_list.join('、') }}
                    </div>
                  </div>
                  <div class="style-body-regular infor_time" style="letter-spacing: 0.56px">
                    <img src="@/assets/images/beauty_time.svg" alt="" />
                    <div>
                      {{ info.time }} {{ info.hour.split(':')[0] >= 12 ? '下午' : '上午'
                      }}{{ info.hour }}
                    </div>
                  </div>
                  <div class="style-body-regular infor_location">
                    <img src="@/assets/images/ic24Location.svg" alt="" />
                    <div>{{ info.store }}</div>
                  </div>
                  <div v-if="info.status === '美容中'">
                    <div class="" style="display: flex; align-items: center; gap: 4px">
                      <div
                        style="
                          font-weight: 500;
                          font-size: 12px;
                          line-height: 14.4px;
                          color: white;
                          padding: 4px 7px;
                          border-radius: 4px;
                          width: fit-content;
                          font-family: Noto Sans TC;
                        "
                        :class="`${getStatusClass(info.status)}`"
                      >
                        <div>
                          {{
                            info.PBS_DTL_INFO.filter(i => i.PBS_DtlStatus === 'P')[0]?.PBS_WrkName
                              ? '美容'
                              : '等待美容'
                          }}中
                        </div>
                      </div>
                      <img
                        v-show="
                          info.PBS_DTL_INFO.filter(i => i.PBS_DtlStatus === 'P')[0]?.PBS_WrkName
                        "
                        :style="{ transform: info.currentOpen ? 'rotate(180deg)' : 'rotate(0deg)' }"
                        src="@/assets/images/ic24ArrowB.svg"
                        alt=""
                      />
                    </div>
                    <div>
                      <div
                        v-show="
                          info.currentOpen &&
                          info.PBS_DTL_INFO.filter(i => i.PBS_DtlStatus === 'P')[0]?.PBS_WrkName
                        "
                        class="style-body-regular"
                        :style="`margin-bottom:-15px;margin-top:16px`"
                      >
                        <div
                          v-for="(PBS_DTL_INFO, index) in info.PBS_DTL_INFO"
                          class="service_item"
                          style="display: flex"
                          :key="index"
                        >
                          <div style="max-height: 24px; min-height: 24px">
                            <div>
                              <div
                                :style="`width: 8px;height: 8px;background-color: ${
                                  PBS_DTL_INFO.PBS_SvrBegTime ? '#ff9f4b' : '#ccc'
                                };border-radius: 100%;position:relative;z-index:2`"
                              ></div>
                              <div
                                :style="`background-color: ${
                                  !PBS_DTL_INFO.PBS_SvrBegTime ||
                                  (PBS_DTL_INFO.PBS_SvrBegTime &&
                                    info.PBS_DTL_INFO[index + 1] &&
                                    !info.PBS_DTL_INFO[index + 1].PBS_SvrBegTime)
                                    ? '#ccc'
                                    : '#FF9F4B'
                                };z-index:1;width: 2px;height: 22px;position:relative;left: 3px;bottom: 2px;${
                                  index == info.PBS_DTL_INFO.length - 1 ? 'opacity:0;' : ''
                                }`"
                              ></div>
                            </div>
                          </div>
                          <!-- info.PBS_DTL_INFO[index + 1]?.PBS_SvrType  -->
                          <div
                            :style="
                              info.PBS_DTL_INFO[index + 1] &&
                              !info.PBS_DTL_INFO[index + 1].PBS_SvrBegTime &&
                              info.PBS_DTL_INFO[index].PBS_SvrBegTime
                                ? 'position:relative;left:8px;bottom:7px;color:#FF9F48;font-weight:700;font-size:14px;max-height: 20px;min-height: 20px;'
                                : 'position:relative;left:8px;bottom:5px;font-size:12px;max-height: 20px;min-height: 20px;'
                            "
                          >
                            {{ PBS_DTL_INFO.PBS_WrkName }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="photo_wrapper">
          <img class="photo" src="@/assets/images/new-logo.png" alt="" />
          <p
            style="
              font-size: 16px;
              font-weight: bolder;
              color: #6f6f6f;
              font-family: 'Noto Sans TC';
            "
          >
            尚未有預約資料
          </p>
          <button
            class="style-btn style-l-btn style-light-btn"
            @click="$store.state.isBeautyEnabled ? $router.push('/salon/order/edit') : showProtect = true"
            style="border-radius: 18px; margin: 0 auto; margin-top: 30px"
          >
            前往預約<img src="@/assets/images/date_b.svg" style="width: 24px; height: 24px" />
          </button>
        </div>
      </div>
    </div>
  </v-main>
</template>

<script>
import BackOnTop from '@/components/BackOnTop.vue'
import Swiper from '@/components/Swiper.vue'
import PopupAlert from '@/components/Popup/PopupAlert.vue'
import {
  KgGetStore,
  KgGetReserveList,
  KgGetPetList,
  KgGetReserve,
  getReserveList,
  KgGetBeauty,
  syncPetData,
  isPetExist,
  KgGetSheetList,
  getRewardActivity,
  showRewardCard,
  pointRecord,
  // getPictList,
  getPetImage,
} from '@/apis/api.js'
export default {
  name: 'PointIndex',
  components: {
    BackOnTop,
    Swiper,
    PopupAlert
  },
  data: () => ({
    isOpen: false,
    showProtect: false,
    storeDict: {},
    sheet: true,
    selectedTime: 0,
    timeSelect: '1',
    barSelect: 0,
    isScrollDown: false,
    selectedType: '',
    selectedStatus: '',
    optionsStatus: ['全部', '美容中', '已預約', '已取消'],
    petDict: {},
    petSelect: '',
    statusDict: {
      0: '未確認',
      3: '已預約',
      4: '已取消',
      S2: '已完成',
      S3: '已完成',
      S1: '美容中',
    },
    ori_history: [],
    ori_reserve_list: [],
    history: [],
    reserve_list: [],
    initial: false,
    own_reserve_list: [],
    timeSelectOptions: [
      {
        text: '由近到遠',
        value: '1',
      },
      {
        text: '由遠到近',
        value: '2',
      },
    ],
    petList: [],
    petImageObj: {},
    ori_beauty_list: [],
    beauty_list: [],
    all_list: [],
    history_page: 1,
    reserve_page: 1,
    start_date: '',
    end_date: '',
    special_list: [],
    currentInfo: 0,
    showPopupCardExchange: false,
    funList: [],
    currentTab: 'card',
    pointCardList: [],
    gg: [],
    couponUndoneList: [],
    couponDoneList: [],
    previous_link: '',
    now_link: '',
    point: 0,
    card_use: '',
    content: '',
  }),
  beforeCreate() {
    this.$store.state.isLoading = true
  },
  created() {
    if (
      !localStorage.getItem('phone') ||
      !localStorage.getItem('password') ||
      !localStorage.getItem('member_no')
    ) {
      this.$router.push('/login')
    } else {
      var parent = this
      // 起始日 結束日為前後各180天
      var numberOfMlSeconds = new Date().getTime()
      var newDateObj = new Date(numberOfMlSeconds - 1000 * 60 * 60 * 24 * 180)
      this.start_date =
        newDateObj.getFullYear().toString() +
        (newDateObj.getMonth() + 1 < 10
          ? '0' + (newDateObj.getMonth() + 1).toString()
          : (newDateObj.getMonth() + 1).toString()) +
        (newDateObj.getDate() < 10
          ? ('0' + newDateObj.getDate()).toString()
          : newDateObj.getDate().toString())
      newDateObj = new Date(numberOfMlSeconds + 1000 * 60 * 60 * 24 * 180)
      this.end_date =
        newDateObj.getFullYear().toString() +
        (newDateObj.getMonth() + 1 < 10
          ? '0' + (newDateObj.getMonth() + 1).toString()
          : (newDateObj.getMonth() + 1).toString()) +
        (newDateObj.getDate() < 10
          ? '0' + newDateObj.getDate().toString()
          : newDateObj.getDate().toString())
      setTimeout(function () {
        if (parent.$store.state.isLoading) {
          parent.showAlert = true
        }
      }, 1000 * 7)
      console.log(this.$route.query.selectedTime)
      syncPetData(localStorage.getItem('phone'), localStorage.getItem('password')).then(
        function () {
          KgGetStore(localStorage.getItem('phone')).then(function (rsp) {
            for (let i in rsp) {
              parent.storeDict[rsp[i].STO_No] = rsp[i].STO_Name
            }
            KgGetPetList(localStorage.getItem('phone'), localStorage.getItem('member_no')).then(
              function (rsp) {
                for (let i in rsp) {
                  parent.petDict[rsp[i].PET_SeqNo] = rsp[i].PET_Name
                  isPetExist(
                    localStorage.getItem('phone'),
                    localStorage.getItem('password'),
                    rsp[i].PET_SeqNo
                  ).then(function (petExistRsp) {
                    if (petExistRsp) {
                      parent.petList.push({
                        text: rsp[i].PET_Name,
                        value: rsp[i].PET_SeqNo,
                      })
                      parent.petImageObj[rsp[i].PET_SeqNo] = require('@/assets/images/imgCard' +
                        rsp[i].PET_Type +
                        '.jpg')
                    }
                  })
                }
                getReserveList(
                  localStorage.getItem('phone'),
                  localStorage.getItem('password'),
                  60
                ).then(function (rsp) {
                  if (rsp.errorMsg) {
                    parent.$store.state.isLoading = false
                    return
                  }
                  parent.own_reserve_list = rsp.map(function (obj) {
                    return obj.c_pbsapptno + obj.e_storeno
                  })
                  if (parent.$route.query.selectedTime != undefined) {
                    parent.selectedType =
                      parent.$route.query.selectedType == undefined
                        ? ''
                        : parent.$route.query.selectedType
                    parent.selectedStatus =
                      parent.$route.query.selectedStatus == undefined
                        ? ''
                        : parent.$route.query.selectedStatus
                    parent.selectedTime = parent.$route.query.selectedTime
                    parent.fetchSheetList()
                    parent.initial = true
                  } else {
                    parent.$store.state.isLoading = false
                    parent.fetchSheetList()
                    parent.initial = true
                  }
                })
              }
            )
          })
        }
      )
      if (parent.$route.query.resultType) {
        parent.barSelect = parent.$route.query.resultType
      }
    }
  },
  mounted() {
    const parent = this
    if (
      !localStorage.getItem('phone') ||
      !localStorage.getItem('password') ||
      !localStorage.getItem('member_no')
    ) {
      parent.$router.push('/login')
    } else {
      this.getRewardCardList().then(function () {
        parent.$store.state.isLoading = false
      })
      getRewardActivity(localStorage.getItem('phone'), localStorage.getItem('password')).then(
        function (rsp) {
          parent.content = JSON.parse(rsp).content
        }
      )
      this.getPointRecord()
    }
  },
  computed: {
    combinedWatcher() {
      return { pointCardList: this.pointCardList, currentInfo: this.currentInfo }
    },
    currentStatus() {
      if (this.barSelect === 0) {
        return this.all_list
      }
      return this.all_list.filter(item => item.status === this.optionsStatus[this.barSelect])
    },
  },
  watch: {
    combinedWatcher: {
      handler() {
        this.funList = [
          {
            title: '新增預約',
            src: require('@/assets/images/pet_reserve.svg'),
            url: 'check',
          },
          {
            title: '集點兌換',
            src: require('@/assets/images/pet_exchange.svg'),
            url: `/point/coupon?id=${
              this.pointCardList.length > 0 ? this.pointCardList[this.currentInfo].id : 0
            }&point=${
              this.pointCardList.length > 0 ? this.pointCardList[this.currentInfo].rm_point : 0
            }`,
          },
          {
            title: '集點歷程',
            src: require('@/assets/images/pet_story.svg'),
            url: '/new_point?id=67890&type=寵知識',
          },
          {
            title: '美容日誌',
            src: require('@/assets/images/pet_record.svg'),
            url: '/salon/new_history',
          },
        ]
      },
      immediate: true,
      deep: true, // 確保深度監聽
    },
    timeSelect() {
      this.filterList()
    },
    petSelect() {
      this.filterList()
    },
  },
  methods: {
    handldPage(num) {
      this.currentPage += num
    },
    changePage(num) {
      this.$refs.listPage.scrollTo(0, 0)
      this.currentPage = num
    },
    fetchSheetList() {
      let store_no_list = Object.keys(this.storeDict)
      this.special_list = []
      let parent = this
      var promises = store_no_list.map(function (store_no) {
        return KgGetSheetList(
          localStorage.getItem('phone'),
          localStorage.getItem('member_no'),
          store_no,
          parent.start_date,
          parent.end_date
        ).then(function (rsp) {
          if (rsp) {
            console.log('fetchSheetList', rsp)
            rsp = rsp.filter(function (obj) {
              if (obj.PBS_ApptNo) {
                return false
              } else {
                return true
              }
            })
            rsp = rsp.map(function (obj) {
              obj.STO_No = store_no
              return obj
            })
            parent.special_list = parent.special_list.concat(rsp)
            return true
          } else {
            return false
          }
        })
      })
      Promise.all(promises).then(function (results) {
        console.log(results)
        parent.special_list = JSON.parse(JSON.stringify(parent.special_list)).map(function (obj) {
          console.log('map obj', obj)
          obj.PBS_CheckInDate = obj.PBS_ShtDate
          obj.PBS_Date = obj.PBS_ShtDate
          obj.PBS_ApptBegTime = obj.CRT_Date.slice(8, 12)
          obj.PBS_ApptNo = obj.PBS_ShtNo
          obj.PBS_No = obj.PBS_ShtNo
          if (['R0', 'R1'].indexOf(obj.PBS_ShtStatus) != -1) {
            obj.PBS_ApptStatus = 3
          } else if (['R3', 'R2'].indexOf(obj.PBS_ShtStatus) != -1) {
            obj.PBS_ApptStatus = 'S1'
          } else if (['R4', 'R5'].indexOf(obj.PBS_ShtStatus) != -1) {
            obj.PBS_ApptStatus = 4
          }
          return obj
        })
        parent.fetchList()
      })
    },
    handleScroll: function (e) {
      var currentScrollPosition = e.srcElement.scrollTop
      if (currentScrollPosition > this.scrollPosition) {
        console.log('Scrolling down')
        this.isScrollDown = false
      } else {
        this.isScrollDown = false
      }
      this.scrollPosition = currentScrollPosition
    },
    getRecordStatusClass(status) {
      let obj = {
        未確認: 'style-salon-history-record-pending',
        已取消: 'new-style-salon-history-record-cancel',
        已預約: 'new-style-salon-history-record-reserve',
        美容中: 'new-style-salon-history-record-beauty',
      }
      return obj[status]
    },
    getStatusClass(status) {
      let obj = {
        未確認: 'style-status-pending',
        已取消: 'style-status-cancel',
        已預約: 'style-status-reserve',
        美容中: 'style-status-beauty',
      }
      return obj[status]
    },
    filterList() {
      console.log('filterList')
      const parent = this
      if (this.petSelect) {
        this.history = JSON.parse(JSON.stringify(this.ori_history)).filter(function (obj) {
          if (obj.pet_id == parent.petSelect) {
            return true
          } else {
            return false
          }
        })
        this.reserve_list = JSON.parse(JSON.stringify(this.ori_reserve_list)).filter(function (
          obj
        ) {
          if (obj.pet_id == parent.petSelect) {
            return true
          } else {
            return false
          }
        })
        this.beauty_list = JSON.parse(JSON.stringify(this.ori_beauty_list)).filter(function (obj) {
          if (obj.pet_id == parent.petSelect) {
            return true
          } else {
            return false
          }
        })
      } else {
        this.history = JSON.parse(JSON.stringify(this.ori_history))
        this.reserve_list = JSON.parse(JSON.stringify(this.ori_reserve_list))
        this.beauty_list = JSON.parse(JSON.stringify(this.ori_beauty_list))
        this.all_list = [...this.beauty_list, ...this.reserve_list]
      }

      // 計算頁數
      this.history_page = Math.ceil(this.history.length / 8)
      this.reserve_page = Math.ceil(this.reserve_list.length / 8)

      // 日期排序
      if (this.timeSelect === '2') {
        // 由遠到近排序
        this.history = JSON.parse(JSON.stringify(this.history)).sort(function (a, b) {
          return new Date(a.time) - new Date(b.time) // 使用日期比較
        })
        this.reserve_list = JSON.parse(JSON.stringify(this.reserve_list)).sort(function (a, b) {
          return new Date(a.time) - new Date(b.time)
        })
        this.beauty_list = JSON.parse(JSON.stringify(this.beauty_list)).sort(function (a, b) {
          return new Date(a.time) - new Date(b.time)
        })
        this.all_list = JSON.parse(JSON.stringify(this.all_list)).sort(function (a, b) {
          return new Date(a.time) - new Date(b.time)
        })
      } else {
        // 由近到遠排序
        this.history = JSON.parse(JSON.stringify(this.history)).sort(function (a, b) {
          return new Date(b.time) - new Date(a.time)
        })
        this.reserve_list = JSON.parse(JSON.stringify(this.reserve_list)).sort(function (a, b) {
          return new Date(b.time) - new Date(a.time)
        })
        this.beauty_list = JSON.parse(JSON.stringify(this.beauty_list)).sort(function (a, b) {
          return new Date(b.time) - new Date(a.time)
        })
        this.all_list = JSON.parse(JSON.stringify(this.all_list)).sort(function (a, b) {
          return new Date(b.time) - new Date(a.time)
        })
      }
    },
    async getImage(tObj, retryCount = 3) {
      let image = await getPetImage(
        localStorage.getItem('phone'),
        localStorage.getItem('password'),
        tObj.PET_SeqNo.toString()
      )

      if (image) {
        tObj['petImg'] = image
      } else {
        if (retryCount > 0) {
          console.warn(`Retrying getImage... Attempts left: ${retryCount}`)
          await this.getImage(tObj, retryCount - 1) // 減少重試次數
        } else {
          console.error('Failed to get image after multiple retries.')
          const petType = tObj.PET_Type || '01'
          tObj['petImg'] = require(`@/assets/images/imgCard${petType}.jpg`)
        }
      }
    },
    async fetchList() {
      console.log('fetchList', this.own_reserve_list)
      this.$store.state.isLoading = true
      var parent = this
      var start_date = this.start_date
      var end_date = this.end_date
      var status

      // 不過濾狀態
      status = ''
      try {
        let rsp = await KgGetReserveList(
          localStorage.getItem('phone'),
          localStorage.getItem('member_no'),
          status,
          start_date,
          end_date
        )

        parent.ori_reserve_list = []
        // 美容紀錄
        parent.ori_history = []
        // 美容中
        parent.ori_beauty_list = []
        console.log(start_date, end_date)
        console.log(rsp, status)
        if (rsp.length == 0 || !rsp) {
          parent.$store.state.isLoading = false
        } else {
          rsp = rsp.concat(parent.special_list)
          var promises = rsp.map(async function (tObj) {
            // for (const tObj of rsp) {
            // let petImg
            // getPetImage(
            //   localStorage.getItem('phone'),
            //   localStorage.getItem('password'),
            //   tObj.PET_SeqNo.toString()
            // ).then(function (image) {
            //   if (image) {
            //     petImg = image
            //   } else {
            //     try {
            //       const petType = tObj.PET_Type || '01'
            //       petImg = require(`@/assets/images/imgCard${petType}.jpg`)
            //     } catch (error) {
            //       console.error(`Failed to load image for PET_Type: ${tObj.PET_Type}`, error)
            //       petImg = require('@/assets/images/imgCard01.jpg')
            //     }
            //   }
            //   tObj['petImg'] = petImg
            // })
            await parent.getImage(tObj)
            if (
              parent.own_reserve_list.indexOf(tObj.PBS_ApptNo + tObj.STO_No) != -1 ||
              ((status == '' || status == 4) &&
                parent.own_reserve_list.indexOf(tObj.PBS_ApptNo + tObj.STO_No) != -1 &&
                tObj.PBS_ApptStatus == 4) ||
              tObj.PBS_ShtType == 'R'
            ) {
              return KgGetReserve(
                localStorage.getItem('phone'),
                localStorage.getItem('member_no'),
                tObj.STO_No,
                tObj.PBS_ApptNo
              ).then(function (inner_rsp) {
                if (!inner_rsp && tObj.PBS_ShtType == 'R') {
                  inner_rsp = tObj
                  console.log('inner_rsp', inner_rsp)
                }
                if (inner_rsp.PBS_ApptBegTime || tObj.PBS_ShtType == 'R') {
                  var hour =
                    inner_rsp.PBS_ApptBegTime.slice(0, 2) +
                    ':' +
                    inner_rsp.PBS_ApptBegTime.slice(2, 4)

                  var date = inner_rsp.PBS_CheckInDate
                  if (!date) date = inner_rsp.PBS_ApptDate
                  let obj = {
                    status: parent.statusDict[inner_rsp.PBS_ApptStatus],
                    name: parent.petDict[tObj.PET_SeqNo],
                    pet_id: tObj.PET_SeqNo,
                    time: [date.slice(0, 4), date.slice(4, 6), date.slice(6, 8)].join('/'),
                    hour: hour,
                    store: parent.storeDict[tObj.STO_No],
                    rating: '',
                    showNotRating: false,
                    id: tObj.PBS_ApptNo,
                    work_id: tObj.PBS_No,
                    store_id: tObj.STO_No,
                    service_list: [],
                    PBS_DTL_INFO: [],
                    PBS_ShtType: tObj.PBS_ShtType ? tObj.PBS_ShtType : '',
                    img: '',
                    currentOpen: false,
                    petImg: tObj.petImg,
                  }
                  obj.rating = inner_rsp.PBS_EvalRemak

                  if (!obj.rating) obj.showNotRating = true
                  if (inner_rsp.PBS_Svr01 == 'Y') {
                    obj.service_list.push('洗澡')
                  }

                  if (inner_rsp.PBS_Svr02 == 'Y') {
                    obj.service_list.push('SPA')
                  }

                  if (inner_rsp.PBS_Svr03 == 'Y') {
                    obj.service_list.push('剪毛')
                  }
                  if (inner_rsp.PBS_Svr04 == 'Y') {
                    obj.service_list.push('游泳')
                  }

                  if (inner_rsp.PBS_ApptStatus == '0')
                    obj.url =
                      '/salon/reserved?id=' +
                      obj.id +
                      '&store_id=' +
                      obj.store_id +
                      '&selectedTime=' +
                      parent.selectedTime +
                      '&selectedType=' +
                      parent.selectedType +
                      '&selectedStatus=' +
                      parent.selectedStatus +
                      '&PBS_ShtType=' +
                      obj.PBS_ShtType
                  if (inner_rsp.PBS_ApptStatus == '3')
                    obj.url =
                      '/salon/reserved?id=' +
                      obj.id +
                      '&store_id=' +
                      obj.store_id +
                      '&selectedTime=' +
                      parent.selectedTime +
                      '&selectedType=' +
                      parent.selectedType +
                      '&selectedStatus=' +
                      parent.selectedStatus +
                      '&PBS_ShtType=' +
                      obj.PBS_ShtType
                  if (inner_rsp.PBS_ApptStatus == '4')
                    obj.url =
                      '/salon/reserved?is_cancel=true&id=' +
                      obj.id +
                      '&store_id=' +
                      obj.store_id +
                      '&selectedTime=' +
                      parent.selectedTime +
                      '&selectedType=' +
                      parent.selectedType +
                      '&selectedStatus=' +
                      parent.selectedStatus +
                      '&PBS_ShtType=' +
                      obj.PBS_ShtType
                  if (
                    inner_rsp.PBS_ApptStatus == 'S1' ||
                    inner_rsp.PBS_ApptStatus == 'S2' ||
                    inner_rsp.PBS_ApptStatus == 'S3'
                  ) {
                    // 確認美容中是否已完成(未按下整張單據完工)
                    return KgGetBeauty(
                      localStorage.getItem('phone'),
                      tObj.STO_No,
                      inner_rsp.PBS_No,
                      inner_rsp.PBS_Date
                    ).then(function (beauty_rsp) {
                      // 美容項目
                      console.log('beauty_rsp', beauty_rsp.PBS_DTL_INFO)
                      obj.PBS_DTL_INFO = JSON.parse(JSON.stringify(beauty_rsp.PBS_DTL_INFO))
                      if (beauty_rsp.PBS_SvrStatus == 2 || beauty_rsp.PBS_SvrStatus == 3) {
                        // 等於已完成
                        obj.status = '已完成'
                        if (obj.rating)
                          obj.url =
                            '/salon/completed?PET_SeqNo=' +
                            tObj.PET_SeqNo +
                            '&PBS_No=' +
                            inner_rsp.PBS_No +
                            '&id=' +
                            obj.id +
                            '&store_id=' +
                            obj.store_id +
                            '&selectedTime=' +
                            parent.selectedTime +
                            '&selectedType=' +
                            parent.selectedType +
                            '&selectedStatus=' +
                            parent.selectedStatus +
                            '&PBS_ShtType=' +
                            obj.PBS_ShtType +
                            '&PBS_Date=' +
                            obj.time.replace(/\//g, '')
                        if (!obj.rating)
                          obj.url =
                            '/salon/process/rating?PET_SeqNo=' +
                            tObj.PET_SeqNo +
                            '&PBS_No=' +
                            inner_rsp.PBS_No +
                            '&id=' +
                            obj.id +
                            '&store_id=' +
                            obj.store_id +
                            '&selectedTime=' +
                            parent.selectedTime +
                            '&selectedType=' +
                            parent.selectedType +
                            '&selectedStatus=' +
                            parent.selectedStatus +
                            '&PBS_ShtType=' +
                            obj.PBS_ShtType +
                            '&PBS_Date=' +
                            obj.time.replace(/\//g, '')
                      }
                      if (
                        (inner_rsp.PBS_ApptStatus == 'S2' || inner_rsp.PBS_ApptStatus == 'S3') &&
                        obj.rating
                      )
                        obj.url =
                          '/salon/completed?PET_SeqNo=' +
                          tObj.PET_SeqNo +
                          '&PBS_No=' +
                          inner_rsp.PBS_No +
                          '&id=' +
                          obj.id +
                          '&store_id=' +
                          obj.store_id +
                          '&selectedTime=' +
                          parent.selectedTime +
                          '&selectedType=' +
                          parent.selectedType +
                          '&selectedStatus=' +
                          parent.selectedStatus +
                          '&PBS_ShtType=' +
                          obj.PBS_ShtType +
                          '&PBS_Date=' +
                          obj.time.replace(/\//g, '')
                      if (
                        (inner_rsp.PBS_ApptStatus == 'S2' || inner_rsp.PBS_ApptStatus == 'S3') &&
                        !obj.rating
                      )
                        obj.url =
                          '/salon/process/rating?PET_SeqNo=' +
                          tObj.PET_SeqNo +
                          '&PBS_No=' +
                          inner_rsp.PBS_No +
                          '&id=' +
                          obj.id +
                          '&store_id=' +
                          obj.store_id +
                          '&selectedTime=' +
                          parent.selectedTime +
                          '&selectedType=' +
                          parent.selectedType +
                          '&selectedStatus=' +
                          parent.selectedStatus +
                          '&PBS_ShtType=' +
                          obj.PBS_ShtType +
                          '&PBS_Date=' +
                          obj.time.replace(/\//g, '')
                      if (['已完成'].indexOf(obj.status) != -1) {
                        // obj.status = '美容中'
                        // parent.ori_beauty_list.push(obj);
                        // return getPictList(
                        //   obj.store_id,
                        //   obj.work_id,
                        //   localStorage.getItem('member_no'),
                        //   obj.pet_id
                        // ).then(function (rsp) {
                        //   console.log('getPictList', rsp)
                        //   if (rsp && rsp.after) {
                        //     if (typeof rsp.after == 'object') {
                        //       obj.img = rsp.after[0]
                        //     } else {
                        //       obj.img = rsp.after
                        //     }
                        //   } else {
                        //     obj.img = parent.petImageObj[obj.pet_id]
                        //   }
                        //   parent.ori_history.push(obj)
                        //   return obj
                        // })
                      } else if (['美容中'].indexOf(obj.status) != -1) {
                        parent.ori_beauty_list.push(obj)
                        // return obj
                      } else {
                        // parent.ori_history.push(obj);
                        parent.ori_reserve_list.push(obj)
                        // return obj
                      }
                    })
                  } else {
                    if (['已完成'].indexOf(obj.status) != -1) {
                      // obj.status = '美容中'
                      // parent.ori_beauty_list.push(obj);
                      // return getPictList(
                      //   obj.store_id,
                      //   obj.work_id,
                      //   localStorage.getItem('member_no'),
                      //   obj.pet_id
                      // ).then(function (rsp) {
                      //   console.log('getPictList', rsp)
                      //   if (rsp && rsp.after) {
                      //     if (typeof rsp.after == 'object') {
                      //       obj.img = rsp.after[0]
                      //     } else {
                      //       obj.img = rsp.after
                      //     }
                      //   } else {
                      //     obj.img = parent.petImageObj[obj.pet_id]
                      //   }
                      //   parent.ori_history.push(obj)
                      //   return obj
                      // })
                    } else if (['美容中'].indexOf(obj.status) != -1) {
                      parent.ori_beauty_list.push(obj)
                      // return obj
                    } else {
                      // parent.ori_history.push(obj);
                      parent.ori_reserve_list.push(obj)
                      // return obj
                    }
                  }
                } else {
                  // return false
                }
              })
            } else {
              // return false
            }
          })
          // parent.filterList()
          // setTimeout(function () {
          //   parent.$store.state.isLoading = false
          // }, 1000)
          Promise.all(promises).then(function (results) {
            console.log(results)

            parent.filterList()
            setTimeout(function () {
              parent.$store.state.isLoading = false
            }, 1000)
          })
        }
      } catch (error) {
        console.log(error)
      }
    },
    handleIndex(index) {
      this.currentInfo = index
    },
    clickTo(url) {
      if(url === 'check'){
        if (this.$store.state.isBeautyEnabled) {
          this.$router.push('/salon/order/edit?where=beauty')
        } else {
          this.showProtect = true
        }
      } else {
        this.$router.push(url)
      }
    },
    togglePopup() {
      this.showPopupCardExchange = !this.showPopupCardExchange
    },
    getPointRecord() {
      const parent = this

      return new Promise(function (resolve) {
        pointRecord(localStorage.getItem('phone'), localStorage.getItem('password')).then(function (
          rsp
        ) {
          rsp = JSON.parse(rsp)
          let filter_date = new Date().getTime() - 1000 * 60 * 60 * 24 * 240
          rsp = rsp.filter(function (obj) {
            var date = new Date(
              `${obj.date.slice(0, 4)}/${obj.date.slice(4, 6)}/${obj.date.slice(6, 8)}`
            ).getTime()
            return date >= filter_date
          })
          rsp = rsp.sort(function (a, b) {
            return b.date - a.date
          })
          parent.msgList = []
          for (let i in rsp) {
            parent.msgList.push({
              title: rsp[i].caption,
              value: rsp[i].point,
              time: `${rsp[i].date.slice(0, 4)}/${rsp[i].date.slice(4, 6)}/${rsp[i].date.slice(
                6,
                8
              )}`,
              detail: rsp[i].content.match('兌換') ? '兌換優惠券一張' : rsp[i].content,
            })
          }
          resolve()
        })
      })
    },
    getRewardCardList() {
      const parent = this
      return new Promise(function (resolve) {
        showRewardCard(localStorage.getItem('phone'), localStorage.getItem('password')).then(
          function (rsp) {
            rsp = JSON.parse(rsp)
            rsp = rsp.sort(function (a, b) {
              return a.e_date - b.e_date
            })
            console.log('showRewardCard', rsp)
            for (let i in rsp) {
              let card_info = rsp[i]
              parent.card_use = {
                id: rsp[0].id,
                rm_point: rsp[0].rm_point,
              }

              if (rsp.length == 1) {
                card_info.type = 'card'
                parent.now_link = `/point/coupon?id=${card_info.id}&point=${card_info.rm_point}`
              } else if (rsp.length > 1) {
                if (i == 0) {
                  // 舊的卡片 orange
                  card_info.type = 'record'
                  parent.previous_link = `/point/coupon?id=${card_info.id}&point=${card_info.rm_point}`
                  parent.point = card_info.rm_point
                } else if (i == 1) {
                  card_info.type = 'card'
                  parent.now_link = `/point/coupon?id=${card_info.id}&point=${card_info.rm_point}`
                }
              }
              parent.pointCardList.push(card_info)
              parent.pointCardList.reverse()
            }
            resolve()
          }
        )
      })
    },
    tabHandler(value) {
      this.currentTab = value
    },
  },
}
</script>
<style lang="scss" scoped>
.box {
  display: flex;
  gap: 12px;
  padding: 19px 20px;
  & .imger {
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding-left: 8px;
    align-items: center;
    & img {
      border-radius: 100%;
    }
    & p {
      font-weight: 400;
      font-size: 12px;
      line-height: 1.2;
      letter-spacing: 4%;
    }
  }
  & .infor {
    display: flex;
    flex-direction: column;
    gap: 8px;
    & .infor_time {
      display: flex;
      align-items: flex-start;
      gap: 4px;
      line-height: 1.2;
    }
    & .infor_location {
      display: flex;
      align-items: center;
      gap: 4px;
    }
  }
}
.reserve_container {
  position: relative;
  padding: 0px 31.5px;
  min-height: 50vh;
  // overflow-y: scroll;
  & .photo_wrapper {
    position: absolute;
    left: 50%;
    top: 60px;
    transform: translate(-50%, 0%);
    & .photo {
      width: 173px;
      aspect-ratio: 173/133;
    }
  }
}
.bar {
  width: 100%;
  padding: 0px 31.5px;
  .tabbar {
    display: flex;
    justify-content: center;
    width: 100%;
    height: 42px;
    margin-bottom: 16px;
    border-bottom: 1px solid #909090;
    color: #909090;
    & div {
      font-weight: 400;
      font-size: 14px;
      line-height: 16.8px;
      letter-spacing: 4%;
      width: 25%;
      align-content: center;
    }
    & div.active {
      color: #ff9f4b;
      position: relative;
      &::after {
        content: '';
        position: absolute;
        bottom: -1px;
        left: 0;
        right: 0;
        height: 2px;
        background-color: #ff9f4b;
      }
    }
  }
}
.func_area {
  display: flex;
  justify-content: space-between;
  padding: 12px 31.5px 24px;
  & div {
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 25%;
    & div {
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #fff;
      border-radius: 100%;
      padding: 10px;
      // filter: drop-shadow(0px 2px 2px #4b25181f);
      box-shadow: 0px 2px 5px #4b251838;
      width: 48px;
      height: 48px;
      margin-bottom: 6px;
    }
    & p {
      color: #363230;
      font-weight: 400;
      font-size: 14px;
      line-height: 16.8px;
      letter-spacing: 4%;
      text-align: center;
    }
  }
}
.title {
  position: relative;
  width: 148px;
  margin: 0 auto;
  padding: 12px 0 24px;
  & p {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -100%);
    white-space: nowrap;
    font-size: 16px;
    font-weight: bold;
    line-height: 19.2px;
    letter-spacing: 4%;
  }
}
h2 {
  color: $color_main_first;
  font-size: 26px;
  font-weight: bold;
  padding: 12px 16px;
  line-height: 1;
  text-align: left;
}
h3 {
  color: $color_main_first;
  font-size: 22px;
  font-weight: bold;
  padding: 12px 0px;
  line-height: 1;
  text-align: left;
}
.list {
  margin-top: 12px;
  padding: 0 16px 70px;
}
.msg_list {
  margin-top: 12px;
  padding: 0 24px 70px;
  list-style: none;

  li {
    align-items: center;
    justify-content: space-between;
    padding: 12px 0;
    border-bottom: 1px solid #e6e6e6;
    .detail {
      text-align: left;
      width: calc(100% - 60px);
      p,
      font {
        margin-bottom: 8px;
        font-size: 14px;
        display: block;
        line-height: 1.4;
      }
      p {
        font-size: 16px;
      }
    }
  }
}
</style>
